import { Switch } from "@mui/material";
import React, { ChangeEvent } from "react";
import { TaskDataRowDataType, TaskTypeClassFontWeight } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesBoldProps {
  taskTypeCol?: ITaskTypeCol;
  onChange?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

export const FormDesignerComponentPropertiesBold = (
    props: IFormDesignerComponentPropertiesBoldProps
) => {
    //NOTE: class name may be used in other style class as prefix or suffix => need to use padding (problem: sText <=> sTextArea)
    const classes = " " + (props.taskTypeCol?.class ?? "") + " ";
    const isLabel = props.taskTypeCol?.dataType === TaskDataRowDataType.Label;

    const handleSwitchChange = (
        _event: ChangeEvent<HTMLInputElement>,
        _checked: boolean
    ) => {
        props.onChange([{
            field: props.taskTypeCol?.field,
            name: "class",
            value: classes
                .replace(" " + TaskTypeClassFontWeight.Normal + " ", " ")
                .replace(" " + TaskTypeClassFontWeight.Bold + " ", " ")
                .trim() +
                (_checked
                    ? (isLabel
                        ? ""
                        : " " + TaskTypeClassFontWeight.Bold)
                    : (isLabel
                        ? " " + TaskTypeClassFontWeight.Normal
                        : "")
                )
        }]);
    };

    return (
        <Switch
            name="fontWeight"
            checked={
                (isLabel && !classes.includes(" " + TaskTypeClassFontWeight.Normal + " ")) ||
                classes.includes(" " + TaskTypeClassFontWeight.Bold + " ")
            }
            onChange={handleSwitchChange}
        />
    );
};
